import http from "../http-common";
import { AxiosResponse } from "axios";

interface Order {
  id?: string | number;
  title?: string;
  clientId?: string | number;
  table_id?: string | number;
  bill_paid?: boolean;
  [key: string]: any;
}

class OrderDataService {
  getAll(): Promise<AxiosResponse<Order[]>> {
    return http.get<Order[]>("/orders");
  }

  get(id: string | number): Promise<AxiosResponse<Order>> {
    return http.get<Order>(`/orders/${id}`);
  }

  getOrderFromTable(id: string | number): Promise<AxiosResponse<Order[]>> {
    return http.get<Order[]>(`/orders/oft/${id}`);
  }

  create(data: Partial<Order>): Promise<AxiosResponse<Order>> {
    return http.post<Order>("/orders", data);
  }

  update(id: string | number, data: Partial<Order>): Promise<AxiosResponse<Order>> {
    return http.put<Order>(`/orders/${id}`, data);
  }

  increment(id: string | number, data: Partial<Order>): Promise<AxiosResponse<Order>> {
    return http.put<Order>(`/orders/${id}`, data);
  }

  delete(id: string | number): Promise<AxiosResponse<any>> {
    return http.delete(`/orders/${id}`);
  }

  deleteAll(): Promise<AxiosResponse<any>> {
    return http.delete(`/orders`);
  }

  findByTitle(title: string): Promise<AxiosResponse<Order[]>> {
    return http.get<Order[]>(`/orders?title=${title}`);
  }

  findByClientId(clientId: string | number): Promise<AxiosResponse<Order[]>> {
    return http.get<Order[]>(`/orders/client/${clientId}`);
  }

  updateBillPaid(id: string | number, data: Partial<Order>): Promise<AxiosResponse<Order>> {
    return http.put<Order>(`/orders/billpaid/${id}`, data);
  }
}

export default new OrderDataService(); 